import dayjs from 'dayjs';

import { RIGHTSIZING_DEFAULT_FILTER_PRESET } from '../../_hooks/useRightsizingTimeRangeSelection';

import { RangePickerCriterion } from '@cast/shared-search-ui';

export const rangeCriterion: RangePickerCriterion = {
  key: 'dateRange',
  initialValue: {
    preset: RIGHTSIZING_DEFAULT_FILTER_PRESET,
    timezone: dayjs.tz.guess(),
  },
};
